export function hasJustificatifsAwaitingValidation(justificatifs) {
    if (!justificatifs || justificatifs.length === 0)
        return false;
    return justificatifs.some((j) => j.status === 'awaitingValidation');
}
